import {ActivatedRouteSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {ModeDataService} from '../editor-state/mode-data.service';
import {SpinnerService} from '../core/spinner/spinner.service';
import {NavigationService} from '../core/navigation/navigation.service';
import {FirebaseDataService} from '../editor-state/firebase-data.service';
import {UndoService} from '../commands/undo.service';
import {DiagramJsonHandlerService} from '../diagram-data/diagram-json-handler.service';
import {DiagramUpdateService} from '../diagram-data/diagram-update.service';
import {DiagramCanvasService} from '../diagram-render/diagram-canvas/diagram-canvas.service';

@Injectable()
export class ViewResolve {
  constructor(
    private modeDataSvc: ModeDataService,
    private spinnerSvc: SpinnerService,
    private navSvc: NavigationService,
    private fbSvc: FirebaseDataService,
    private undoSvc: UndoService,
    private jsonHandler: DiagramJsonHandlerService,
    private diagramUpdateSvc: DiagramUpdateService,
    private canvasService: DiagramCanvasService
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const diagramId = route.params.diagramId;
    const state = route.queryParams.v;
    const mode = !!route.queryParams.edit;
    const top = route.queryParams.top;
    const originSrc = route.queryParams.originSrc;
    const authorisation = route.queryParams.authorisation;

    this.navSvc.setCurrent(diagramId, state, true, top, originSrc, authorisation);
    this.modeDataSvc.modeSwitch(mode);
    // this.spinnerSvc.hide();
  }

  canDeactivate(): Promise<boolean> | boolean {
    this.undoSvc.clear();

    const diagramJson = this.jsonHandler.get();

    this.canvasService.saveViewportPosition(diagramJson);

    if (this.modeDataSvc.isEditMode()) {
      // flush pending autosaves before unlocking so view mode renders the persisted edits
      return this.diagramUpdateSvc
        .flush()
        .then(() => this.fbSvc.unlockSelf())
        .then(() => true);
    }

    return true;
  }
}
